import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';

import { ProductItem } from '../../shared/models/product';
import { ProductService } from './product.service';

export const productResolver: ResolveFn<ProductItem | null> = async (
    route: ActivatedRouteSnapshot,
) => {
    const productService = inject(ProductService);

    const modalitySlug = route.paramMap.get('modality');
    const productSlug = route.paramMap.get('product');
    const consoleSlug = route.queryParamMap.get('console') ?? undefined;

    if (!modalitySlug || !productSlug) {
        return null;
    }

    return productService.loadFullProductData(
        modalitySlug,
        productSlug,
        consoleSlug,
    );
};
